export default "__VITE_ASSET__CQbl5RcM__"